import { useSyncExternalStore } from "react";

const QUERY = "(max-width: 992px)";
const mql = typeof window !== "undefined" ? window.matchMedia(QUERY) : null;

function subscribe(onStoreChange: () => void): () => void {
  if (!mql) return () => {};
  mql.addEventListener("change", onStoreChange);
  return () => mql.removeEventListener("change", onStoreChange);
}

function getSnapshot(): boolean {
  // Narrow viewport alone isn't enough — a resized desktop Chrome window
  // shouldn't get native mobile pickers (they don't open on click).
  // Require both narrow width AND a touch-capable device.
  return !!mql?.matches && isTouchDevice();
}

function getServerSnapshot(): boolean {
  return false;
}

function isTouchDevice(): boolean {
  return "ontouchstart" in window || navigator.maxTouchPoints > 0;
}

/**
 * Reactive mobile detection — narrow viewport AND touch-capable.
 * Updates on resize/rotation. Desktop browsers at narrow widths
 * still get the rich (non-native) controls.
 */
export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
